import { Action } from '@ngrx/store';

import { Area, CommissioningPackage, CpComponents } from '@completion/models';

export enum CommissioningPackageActionTypes {
  AreaLoad = 'Area Load',
  AreaLoadSuccess = 'Area Load Success',
  CpCreate = 'Cp Create',
  CPComponentLoad = 'CPComponent Load',
  CPComponentLoadSuccess = 'CPComponent Load Success',
  UpdateError = 'UpdateError',
  ClearError = 'ClearError',
}

export class AreaLoad implements Action {
  readonly type = CommissioningPackageActionTypes.AreaLoad;
}

export class AreaLoadSuccess implements Action {
  readonly type = CommissioningPackageActionTypes.AreaLoadSuccess;

  constructor(public areas: Area[]) {}
}

export class CpCreate implements Action {
  readonly type = CommissioningPackageActionTypes.CpCreate;

  constructor(public cp: CommissioningPackage) {}
}

export class CPComponentLoad implements Action {
  readonly type = CommissioningPackageActionTypes.CPComponentLoad;
}

export class CPComponentLoadSuccess implements Action {
  readonly type = CommissioningPackageActionTypes.CPComponentLoadSuccess;

  constructor(public cpComponent: CpComponents) {}
}

export class UpdateError implements Action {
  readonly type = CommissioningPackageActionTypes.UpdateError;

  constructor(public errorMessage: string) {}
}

export class ClearError implements Action {
  readonly type = CommissioningPackageActionTypes.ClearError;
}

export type CommissioningPackageActions =
  | AreaLoad
  | AreaLoadSuccess
  | CpCreate
  | CPComponentLoad
  | CPComponentLoadSuccess
  | UpdateError
  | ClearError;
